module.exports = __webpack_public_path__ + "static/media/oberflex-aulne-1200x2490.4a945261.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-aulne-1200x2490.jpg
// module id = 980
// module chunks = 37